// @ts-nocheck
import React from 'react'
import { SaveButton, Toolbar, useTranslate } from 'react-admin'
// import SaveButton from 'elements/proUXButtons/SaveButton'

import { ProjectTransactionType } from 'types/projectTransactions'

import { makeStyles } from 'opensolar-ui'
const useStylesToolbar = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
  },
})

const useStyles = makeStyles({
  footer: {
    margin: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  rightButtonGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  cancelButtonWrapper: {
    marginRight: '15px',
  },
  leftButton: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
})

type PropTypes = {
  onSuccess: Function
  onFailure: Function
  onDelete: Function
  onDismiss: () => void
  record: ProjectTransactionType
  handleSubmitWithRedirect: Function
  handleSubmit: Function
  invalid: boolean
  pristine: boolean
  saving: boolean
}

const ToolBarContents = (props: PropTypes) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <div className={classes.footer}>
      <div className={classes.leftButton}></div>
      <div className={classes.rightButtonGroup}>
        <div>
          <SaveButton
            {...props}
            redirect={false}
            submitOnEnter={true}
            onSave={(values: object, redirect: string, form: any, defaultSaveFunc: Function) => {
              defaultSaveFunc(values, redirect, { onSuccess: props.onSuccess, onFailure: props.onFailure })
            }}
          />
        </div>
      </div>
    </div>
  )
}

const CustomizedToolbar: React.FunctionComponent<any> = (props) => {
  return (
    <Toolbar {...props} classes={useStylesToolbar()}>
      <ToolBarContents {...props} />
    </Toolbar>
  )
}

export default CustomizedToolbar
